/**
 * Created by kb on 2017/11/17.
 */
/**
 * element-ui 弹出提示公用方法
 * @type {{}}
 */
export const elNotice = {
  duration: 2500,
  msgType: {
    成功: "success",
    警告: "warning",
    信息: "info",
    错误: "error",
  },
  /**
   * 消息提示方法
   * @param msg  提示信息
   * @param msgType  信息类型
   * @param closeCallBack 提示信息关闭后的回调方法（如果有）
   * @returns {*}
   */
  message(msg, msgType, closeCallBack){
    return this.$message({
      message: msg, type: msgType, showClose: true, duration: this.duration, onClose: () => {
        typeof(closeCallBack) === "function" && closeCallBack();
      }
    });
  },
  /**
   * 弹框提示方法
   * @param msg  提示信息
   * @param callback 弹框关闭后回调方法
   * @param type  弹框类型
   * @param title  弹框标题
   * @param confirmButtonText 弹框确定按钮显示的文本
   * @param lockScroll  弹框是否锁定body滚动条
   * @returns {*}
   */
  alert(msg, callback = () => {
  }, type = elNotice.msgType.信息, title = "提示", confirmButtonText = "确定", lockScroll = true){
    return this.$alert(msg, title, {
      confirmButtonText: confirmButtonText,
      lockScroll: lockScroll,
      callback: () => {
        callback()
      },
      type: type
    });
  },
  /**
   *  confirm提示框
   * @param msg  提示信息
   * @param callBack 确定回调方法
   * @param cancelBack  取消回调方法
   * @param type confirm提示类型
   * @param title 提示标题
   * @param confirmText  确定按钮显示的文本
   * @param cancelText   取消按钮显示的文本
   */
  confirm: function (msg, callBack = () => {
  }, cancelBack = () => {
  }, type = elNotice.msgType.警告, title = "提示", confirmText = "确定", cancelText = "取消") {
    this.$confirm(msg, title, {
      confirmButtonText: confirmText,
      cancelButtonText: cancelText,
      type: type
    }).then(
      callBack
    ).catch(
      cancelBack
    );
  }
}


export const $msg = {
  _this:null,
  //初始化vue对象
  init(_this){
    elNotice._this = _this;
  },
  duration: 2500,
  msgType: {
    成功: "success",
    警告: "warning",
    信息: "info",
    错误: "error",
  },
  /**
   * 消息提示方法
   * @param msg  提示信息
   * @param msgType  信息类型
   * @param closeCallBack 提示信息关闭后的回调方法（如果有）
   * @returns {*}
   */
  message(msg, msgType, closeCallBack){
    return elNotice._this.$message({
      message: msg, type: msgType, showClose: true, duration: elNotice.duration, onClose: () => {
        typeof(closeCallBack) === "function" && closeCallBack();
      }
    });
  },
  /**
   * 弹框提示方法
   * @param msg  提示信息
   * @param callback 弹框关闭后回调方法
   * @param type  弹框类型
   * @param title  弹框标题
   * @param confirmButtonText 弹框确定按钮显示的文本
   * @param lockScroll  弹框是否锁定body滚动条
   * @returns {*}
   */
  alert(msg, callback = () => {
  }, type = elNotice.msgType.信息, title = "提示", confirmButtonText = "确定", lockScroll = true){
    return elNotice._this.$alert(msg, title, {
      confirmButtonText: confirmButtonText,
      lockScroll: lockScroll,
      callback: () => {
        callback()
      },
      type: type
    });
  },
  /**
   *  confirm提示框
   * @param msg  提示信息
   * @param callBack 确定回调方法
   * @param cancelBack  取消回调方法
   * @param type confirm提示类型
   * @param title 提示标题
   * @param confirmText  确定按钮显示的文本
   * @param cancelText   取消按钮显示的文本
   */
  confirm: function (msg, callBack = () => {
  }, cancelBack = () => {
  }, type = elNotice.msgType.警告, title = "提示", confirmText = "确定", cancelText = "取消") {
    elNotice._this.$confirm(msg, title, {
      confirmButtonText: confirmText,
      cancelButtonText: cancelText,
      type: type
    }).then(
      callBack
    ).catch(
      cancelBack
    );
  }
}



// WEBPACK FOOTER //
// ./src/commonJs/objExtend/elNotice.js